module.exports = __webpack_public_path__ + "img/b6.92ae1d8f.jpeg";